import confused from "../assets/pokemon-confused.gif";

function Error404() {
  return (
    <div className="h-screen pt-52 flex flex-col justify-center items-center gap-8 bg-sky-200">
      <p className="text-4xl">Page Not Found</p>
      <h2 className="error-404 text-8xl  font-bold text-center text-yellow-400 ">
        404 ERROR
      </h2>
      <img src={confused} alt="confused" className="max-h-96 max-w-[360px]" />
    </div>
  );
}

export default Error404;
